<header
  [class.pdw-head]="isProductionDeviation()"
  [class.pdw-head--with-summary]="isProductionDeviation()"
  [class.detail-card-header--production-deviation]="isProductionDeviation()"
  class="detail-card-header">
  @if (isProductionDeviation()) {
    <div class="pdw-head__main">
      <div class="pdw-head__title-row">
        <span class="pdw-head__kind pdw-head__kind--production-deviation">Production deviation</span>
      </div>
      <h2 class="pdw-head__title">{{ item().title }}</h2>
      <p class="pdw-head__sub">
        <span class="detail-confidence">Confidence: {{ getConfidenceLabel() }}</span>
      </p>
    </div>
  } @else {
    <div class="detail-card-header__text">
      <div class="detail-case-id">
        <span class="detail-case-id__label">Case Id</span>
        <span class="detail-case-id__value">{{ caseId() }}</span>
      </div>
      <h2 class="detail-title">{{ item().title }}</h2>
      <span class="detail-confidence">Confidence: {{ getConfidenceLabel() }}</span>
    </div>
  }

  <div [class.pdw-head__actions]="isProductionDeviation()" class="detail-network-action">
    <ng-content select="[headerFeedback]" />
    <button
      #networkContextTrigger
      [attr.aria-expanded]="networkBladeOpen()"
      (click)="onNetworkContextOpened()"
      type="button"
      class="detail-network-action__button"
      aria-controls="uc2-network-context">
      <i class="pi pi-sitemap" aria-hidden="true"></i>
      <span>{{ isProductionDeviation() ? 'Network context' : 'Network diagram' }}</span>
    </button>
  </div>
  @if (isProductionDeviation()) {
    <div class="detail-header-summary">
      @if (summaryText().trim().length > 0) {
        <p class="detail-header-summary__text">{{ summaryText() }}</p>
      } @else {
        <p class="detail-header-summary__text detail-header-summary__text--empty">No summary available.</p>
      }
      <hr class="detail-header-summary__divider" />
    </div>
    <dl class="pdw-head__facts" aria-label="Production deviation details">
      <div>
        <dt>Agent Case ID</dt>
        <dd class="detail-case-id__value">{{ caseId() }}</dd>
      </div>
      <div>
        <dt>Production Date</dt>
        <dd>@if (productionDay(); as day) { {{ day | date:'dd MMM yyyy':'+0100' }} WAT } @else { Not recorded }</dd>
      </div>
      <div>
        <dt>Detected</dt>
        <dd>@if (detectedUtc(); as detected) { {{ detected | date:dateFormat:'+0100' }} WAT } @else { Not recorded }</dd>
      </div>
    </dl>
  }
</header>

<app-uc2-network-blade
  [open]="networkBladeOpen()"
  [wellCode]="primaryAssetLabel()"
  [assetCodes]="previewAssetCodes()"
  (closed)="onNetworkContextClosed()" />
